export default __webpack_public_path__ + "imgs/relaxation.fa1d5b6ddaf8b2511448a31a9ccfb08a.svg";